"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateVenueOpeningHoursRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const VenueOpeningHours_dto_1 = require("../response/VenueOpeningHours.dto");
class UpdateVenueOpeningHoursRequestDto {}
exports.UpdateVenueOpeningHoursRequestDto = UpdateVenueOpeningHoursRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: VenueOpeningHours_dto_1.VenueOpeningHoursDto,
  nullable: true,
  description: 'Manual opening hours override. Pass null to clear the override and fall back to Google hours when available.'
}), __metadata("design:type", Object)], UpdateVenueOpeningHoursRequestDto.prototype, "openingHours", void 0);
//# sourceMappingURL=UpdateVenueOpeningHoursRequest.dto.js.map